export default __webpack_public_path__ + "static/media/AO-2.888a14d7.jpg";